const findRowIndexById = (tanStackTable, rowId) => {
  if (!tanStackTable) {
    return -1;
  }

  const { flatRows } = tanStackTable.getSortedRowModel();

  // Track collapsed row IDs so we can skip their descendants.
  // When a row's parentId is in this set, the row is hidden and its own ID
  // is added so grandchildren are also skipped — all in a single O(n) pass.
  const collapsedIds = new Set();
  let visibleIndex = 0;

  for (const row of flatRows) {
    if (row.parentId !== undefined && collapsedIds.has(row.parentId)) {
      collapsedIds.add(row.id);
      continue;
    }

    if (row.id === rowId) {
      return visibleIndex;
    }

    if (!row.getIsExpanded()) {
      collapsedIds.add(row.id);
    }

    visibleIndex++;
  }

  return visibleIndex;
};

export default findRowIndexById;
